import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreviewCardComponent } from 'src/app/features-modules/preview/components/preview-card/preview-card.component';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
declare var $: any;

interface Card {
  CardId: number;
  CardTemplateId: string;
  CategoryId: string;
  SubCategoryId: number;
  NameEnglish: number;
  NameArabic: string;
  Description: string;
  ImageState: string;
  OriginalImage: string;
  PlaceholderImage: string;
  GIFImage: string;
  ThumbnailImage: string;
  VideoFilePath: string;
  NumberOfViews: number;
  Price: string;
  FinalPrice: string;
  PriceAED: string;
  FinalPriceAED: string;
  PriceINR: string;
  FinalPriceINR: string;
  DiscountPercentage: string;
  CreatedBy: number;
}

@Component({
  selector: 'app-card-post',
  templateUrl: './card-post.component.html',
  styleUrls: ['./card-post.component.css'],
})
export class CardPostComponent implements OnInit {
  @Input() card: Card;
  @Input() loader: string = 'assets/images/GIF/tenor.gif';
  @Input() height: number = 50;
  @Input() width: number = 50;
  @Input() image: string;

  constructor(
    private _router: Router,
    public sharedService: SharedService,
    public httpService: HTTPService,
    public ngbModel: NgbModal
  ) {
    this.isLoading = true;
  }

  isLoading: boolean;

  hideLoader() {
    this.isLoading = false;
  }

  ngOnInit(): void { }

  public loadImgSrc(imageId) {
    $('#img' + imageId).attr('src', this.card?.GIFImage);
  }

  GoToPreviewCard(item) {
    // let encryptedqueryparams: { cardId: any, categoryId: any, subCategoryId: any };
    // encryptedqueryparams = {
    //   cardId: item?.CardId,
    //   categoryId: item?.CategoryId,
    //   subCategoryId: item?.SubCategoryId
    // };
    // this._router.navigate([`/preview/${item.NameEnglish.replace(/  +/g, "-")}/card/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
    const modelRef = this.ngbModel.open(PreviewCardComponent, {
      size: 'lg',
      windowClass: 'modal-holder modal-cards',
      centered: true,
    });
    modelRef.componentInstance.cardId = item?.CardId;
    modelRef.componentInstance.categoryId = item?.categoryId;
    modelRef.componentInstance.subCategoryId = item?.subCategoryId;
    modelRef.result.then((data: boolean) => {
      if (data) {
        let encryptedqueryparams: { videoId: any };
        encryptedqueryparams = {
          videoId: item?.VideoId,
        };
        const url = `/preview/${item.NameEnglish.replace(/ +/g, '-')}/video/${this.sharedService.encryptData(
          JSON.stringify(encryptedqueryparams)
        )}`;

        window.open(url, '_blank');
      }
    });
  }
}
